module.exports = __webpack_public_path__ + "static/media/Avatar-Gabi.27510dc4.png";